<script setup>
import {defineProps, defineEmits} from "vue";

defineProps(['show']);
defineEmits(['close', 'openMap']);

</script>

<template>
  <Transition name="fade">
    <div class="visit-modal" v-if="show">
      <p>Открыть карту?</p>
      <div class="visit-modal__btns">
        <button
          class="link-default"
          :disabled="disabled"
          @click="$emit('openMap')"
      >
        Да
      </button>
      <button
          class="link-default"
          :disabled="disabled"
          @click="$emit('close')"
      >
        Нет
      </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.visit-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  z-index: 10000001;
  padding: 2.5rem 2rem 2rem 2rem;
  position: absolute;
  top: 100px;
  left: 50px;
  border-radius: 1.5rem;
  gap: 10px;
  background: #fff;
}

.visit-modal__btns {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.link-default {
  flex: 0 0 50%;
}

.link-default:last-child {
  background-color: rgb(215, 45, 65);
}
</style>
